import axios from 'axios';
import Vue from 'vue';

export function notify (type, title, text) {
  Vue.prototype.$notify({
    title   : title,
    text    : text,
    position: 'bottom right',
    type    : type
  });
}

export async function verificarAccesoEditar (to, from, next) {
  try {
    const params = {
      empresa: process.env.EMPRESA,
      token: localStorage.getItem('token')
    };
    if (+to.params.idReunion === 0) {
      next();
      return;
    }

    const response = await axios.get(`/reunion/gestion/${to.params.idReunion}/verificar/acceso/editar`, { params });

    if (response.data.status === 1) {
      next();
    } else {
      notify('error', 'Error', 'No tiene acceso');
      next('/mis-reuniones');
    }
  } catch (error) {
    notify('error', 'Error', error.message);
    next('/mis-reuniones');
  }
}

export async function verificarAccesoEsAsistente (to, from, next) {
  try {
    const params = {
      empresa: process.env.EMPRESA,
      token: localStorage.getItem('token')
    };

    const response = await axios.get(`/reunion/gestion/${to.params.idReunion}/verificar/acceso/es-asistente`, { params });

    if (response.data.status === 1) {
      next();
    } else {
      notify('error', 'Error', 'No tiene acceso');
      next('/mis-reuniones');
    }
  } catch (error) {
    notify('error', 'Error', error.message);
    next('/mis-reuniones');
  }
}



// WEBPACK FOOTER //
// ./src/router/guards.js